import { TextField } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { HTTP_STATUSES } from "../../../../utils/consts";
import { fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";

const VerificationAttributesContainer = ({
  invoiceData,
  setInvoiceData,
  notification,
  setNotification,
  serviceName,
  verificationType
}) => {
  const { t } = useTranslation("documentsPage");

  const [verificationAttributes, setVerificationAttributes] = useState(null);

  useEffect(() => {
    let filterUrl = fetchFilterData({
      "service.name": serviceName,
      "verificationType": verificationType
    });

    axios.get("/api/verification-attributes" + filterUrl, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setVerificationAttributes(response.data);
      }
    }).catch(error => {
      setNotification({
        ...notification,
        visible: true,
        type: "error",
        message: error.response.data.detail
      });
    });
  }, []);

  const handleChangeAttribute = (event, id) => {
    event.preventDefault();

    const { value } = event.target;

    const elementsIndex = invoiceData?.attributes.findIndex((element) => element.attribute === id);

    let newArray = [...invoiceData?.attributes];

    if (elementsIndex === -1) {
      setInvoiceData({
        ...invoiceData,
        attributes: newArray.concat({
          attribute: id,
          value: value
        })
      });
    } else {
      newArray[elementsIndex] = {
        ...newArray[elementsIndex],
        value: value
      };

      setInvoiceData({ ...invoiceData, attributes: newArray });
    }
  };

  const renderAttributes = ({ id, name }) => {
    const element = invoiceData?.attributes?.find((element) => element.attribute === id);

    switch (name) {
      default: {
        return (
          <TextField
            id={name}
            name={name}
            label={t(`checkForm.${name}`)}
            value={element?.value}
            onChange={(event) => handleChangeAttribute(event, id)}
          />
        );
      }
    }
  };

  return (
    <>
      {verificationAttributes && verificationAttributes.map(({ id, name, ...props }) => {
          return (
            <React.Fragment key={name}>
              {renderAttributes({ id, name, ...props })}
            </React.Fragment>
          );
        }
      )}
    </>
  );
};

export default VerificationAttributesContainer;